import React from 'react';
import { Page, Hero } from '../AdminKit';

const queueURL = 'https://store.antsnest.co.kr/Admin/agent-submissions';
export default function AgentSubmissions() {
  return <Page>
    <Hero><h1>에이전트 제품 등록 대기열</h1>
      <p>제품 내용과 조사 근거를 확인하고 승인·반려합니다. 스토어에 로그인한 계정의 제출 제품이 표시됩니다.</p>
      <a href={queueURL} target="_blank" rel="noopener noreferrer">대기열을 새 창에서 열기 · 로그인</a>
    </Hero>
    <iframe title="에이전트 제품 등록 대기열" src={queueURL} style={{ width: '100%', height: '75vh', minHeight: 560, border: '1px solid #e3ebf7', borderRadius: 8, background: '#fff' }} />
  </Page>;
}
